'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMessages = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends12 = require('babel-runtime/helpers/extends');

var _extends13 = _interopRequireDefault(_extends12);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;

var _console = require('./console');

var _acceptedMessageBuilder = require('../../utils/acceptedMessageBuilder');

var _acceptedMessageBuilder2 = _interopRequireDefault(_acceptedMessageBuilder);

var _reselect = require('reselect');

var _catalogRegistration = require('./catalogRegistration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* helpers */
var addMessage = function addMessage(messages, newMessages) {
    messages = [].concat((0, _toConsumableArray3.default)(messages));
    if (Array.isArray(newMessages)) {
        newMessages.forEach(function (message) {
            return doAdMessage(messages, message);
        });
    } else {
        doAdMessage(messages, newMessages);
    }

    if (messages.length > 500) {
        messages = messages.splice(messages.length - 50, 50);
    }
    return messages;
};

var doAdMessage = function doAdMessage(messages, message) {
    messages.push(message);
    messages.sort(function (a, b) {
        return a.created - b.created;
    });
};

/* reducer */
var DEFAULT_STATE = {
    byId: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ref = action.payload || {},
        amount = _ref.amount,
        approved = _ref.approved,
        ask = _ref.ask,
        askPrice = _ref.askPrice,
        bidderId = _ref.bidderId,
        bidderOutbid = _ref.bidderOutbid,
        catalogId = _ref.catalogId,
        created = _ref.created,
        currency = _ref.currency,
        lotNumber = _ref.lotNumber,
        missiveText = _ref.missiveText,
        myBid = _ref.myBid,
        paddleNumber = _ref.paddleNumber,
        previousBidAmount = _ref.previousBidAmount,
        source = _ref.source,
        wasApproved = _ref.wasApproved;

    var existing = state.byId[catalogId] || [];

    switch (action.type) {
        case _console.BID_ACCEPTED:
            var newMessages = (0, _acceptedMessageBuilder2.default)({
                amount: amount,
                bidderId: bidderId,
                created: created,
                currency: currency,
                myBid: myBid,
                outbid: bidderOutbid,
                paddleNumber: paddleNumber,
                previousBidAmount: previousBidAmount,
                source: source
            });

            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, newMessages)))
            });
        case _console.BID_RETRACTED:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: {
                        amount: ask,
                        currency: currency,
                        myBid: myBid
                    },
                    type: 'retracted'
                })))
            });
        case _console.LOT_PASSED:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: { lotNumber: lotNumber },
                    type: 'passed'
                })))
            });
        case _console.LOT_REOPENED:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: { lotNumber: lotNumber },
                    type: 'reopened'
                })))
            });
        case _console.LOT_SKIPPED:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: { lotNumber: lotNumber },
                    type: 'skipped'
                })))
            });
        case _console.LOT_SOLD:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: {
                        amount: amount,
                        bidderId: bidderId,
                        currency: currency,
                        lotNumber: lotNumber,
                        myBid: myBid,
                        paddleNumber: paddleNumber
                    },
                    type: 'sold'
                })))
            });
        case _console.LOT_UNSOLD:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: { lotNumber: lotNumber },
                    type: 'unsold'
                })))
            });
        case _console.MISSIVE:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    text: missiveText,
                    type: 'missive'
                })))
            });
        case _catalogRegistration.LOAD_CATALOG_REGISTRATION_SUCCESS:
            if (!wasApproved && approved) {
                existing = addMessage(existing, {
                    created: created,
                    type: 'approved'
                });
            }

            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, existing))
            });
        case _console.NEXT_LOT_LOADED:
            return (0, _extends13.default)({}, state, {
                byId: (0, _extends13.default)({}, state.byId, (0, _defineProperty3.default)({}, catalogId, addMessage(existing, {
                    created: created,
                    data: {
                        amount: askPrice,
                        currency: currency,
                        lotNumber: lotNumber
                    },
                    type: 'opened'
                })))
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.consoleMessages;
};
var idSelector = function idSelector(state, id) {
    return id;
};
var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});
var getMessages = exports.getMessages = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/consoleMessages.js
// module id = KUDK
// module chunks = 60